var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpandIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.6835 6.76656C0.306015 6.76656 0 7.07258 0 7.45003V11.3165C0 11.694 0.306015 12 0.6835 12H4.54998C4.92743 12 5.23345 11.694 5.23345 11.3165C5.23345 10.939 4.92743 10.633 4.54998 10.633H2.33362L5.35543 7.61116C5.62238 7.34422 5.62238 6.91144 5.35543 6.6445C5.08857 6.37763 4.65579 6.37763 4.38885 6.6445L1.367 9.66641V7.45003C1.367 7.07258 1.06098 6.76656 0.6835 6.76656ZM6.76628 0.683733C6.76628 0.306246 7.07229 0.000230537 7.44982 0.000230537H11.2986C11.4795 -0.00445216 11.6618 0.0622018 11.7998 0.200192C11.9378 0.33819 12.0045 0.520517 11.9998 0.701337V4.55019C11.9998 4.92771 11.6938 5.23373 11.3162 5.23373C10.9388 5.23373 10.6328 4.92771 10.6328 4.55019V2.33385L7.61088 5.35572C7.34393 5.62266 6.91123 5.62266 6.64429 5.35572C6.37735 5.08877 6.37735 4.656 6.64429 4.3891L9.66611 1.36724H7.44982C7.07229 1.36724 6.76628 1.06122 6.76628 0.683733Z",
    fill: "#8E8E8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandIcon);
export default __webpack_public_path__ + "static/media/ExpandIcon.6772dba127ea067bf31f9cb678c3a6c0.svg";
export { ForwardRef as ReactComponent };